<div class="email-view-page__layout">
    <main class="email-view-page__message">
        <tt-email-viewer [emailKeyno]="emailKeyno" (messageLoaded)="onMessageLoaded($event)" (attachmentClick)="openAttachment($event)"></tt-email-viewer>
    </main>

    <aside class="email-view-page__sidebar" *ngIf="!!page">
        <section class="email-view-page__actions" aria-label="Email actions">
            <div class="email-view-page__reply-actions">
                <tt-button ttText="emailview_send_email" ttIcon="far fa-reply" ttType="primary" (ttClick)="replyToEmail($event)"></tt-button>
                <tt-button ttText="emailview_send_email_all" ttIcon="far fa-reply-all" ttType="primary" (ttClick)="replyToAllEmail($event)"></tt-button>
            </div>
            <tt-button *ngIf="page.show_delete === '1'" ttText="emailview_delete" ttIcon="fad fa-trash" ttType="danger" [ttLoading]="deleting" (ttClick)="deleteEmail()"></tt-button>
            <tt-button-settings *ngIf="page.show_setting === '1'" ttWebpageName="emailview" (ttClick)="openSettings($event)"></tt-button-settings>
        </section>

        <section *ngIf="loadingReplies || replies.length" class="email-view-page__replies">
            <div *ngIf="loadingReplies" class="email-view-page__reply-skeleton" aria-label="Loading replies"></div>
            <tt-list *ngIf="!loadingReplies" [ttData]="replies"></tt-list>
        </section>
    </aside>
</div>
